import type { ReactElement } from 'react';

import DentistSearch from '../../components/DentistSearch';

export default function AnafeSaude(): ReactElement {
  return <DentistSearch variant="anafe" />;
}
